import OSS from "ali-oss";
import reg from "./reg"
const OSSConfig = {
	uploadHost: 'https://demo-java.oss-cn-hangzhou.aliyuncs.com/', //OSS上传地址
	type: 'scs',
	ossParams: {
		region: 'oss-cn-hangzhou',
		success_action_status: '200', // 默认200
		accessKeyId: 'LTAI5tFwyRcJaqK2USpZ8UUZ',
		accessKeySecret: 'e39JXDUsaQ8uIyskER0AyOdf9MvuFd',
		bucket: 'demo-java',
	},
}

function random_string(len) {
	len = len || 32
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
	var maxPos = chars.length
	var pwd = ''
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}

/**
 *
 * @param event 上传图片的资源路径
 * @param type 图片资源类型
 * @param dir oss要保存的文件夹
 * @returns {OSS文件路径}
 */

function uploadOSS(file) {
    return new Promise(async(resolve, reject) => {
        var client = new OSS({
            region: OSSConfig.ossParams.region,
            accessKeyId: OSSConfig.ossParams.accessKeyId,
            accessKeySecret: OSSConfig.ossParams.accessKeySecret,
            secure:true,
            bucket: OSSConfig.ossParams.bucket,
        });
		let fileName = reg.getFileType(file.name)
        const aliyunFileKey = 'LVJU/image' + '/' + new Date().getTime() + Math.floor(Math.random() * 150)+'.'+ fileName;
        var result = await client.multipartUpload(aliyunFileKey, file)
        var url = OSSConfig.uploadHost + result.name
        resolve(url);
    });
}

export { uploadOSS }